import BaseRegulation from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import { DkStructuredLogging } from './logging/dk_structured_logging';
import {Check} from "@sparkware/app-utils";
import { GameChildishIconMode } from '../../../../../../common/enums/game-childish-icon-mode.enum';
import {GNWP_SOURCES} from '../../../../../../app-react/services/gnwp/gnwp-consts';

export default class DkRegulation extends BaseRegulation {
  static CLASS = 'DkRegulation';

  _structuredLogger = null;



  init(params) {
    super.init(params);

    this._structuredLogger = DkStructuredLogging.create({
      serviceFactory: this.serviceFactory,
    });

  }

    sessionTimerVisible() {
        return true;
    }
  realityCheckEnabled() {
    return true;
  }

  sessionTimerEnabled() {
    return true;
  }

  showResponsibleIcons() {
    return true;
  }

  showAgeResponsibleGameInDetailedHistory() {
    return true;
  }

  showAgeResponsibleIconInGame() {
    return true;
  }

  getChildishIconMode() {
    if (!this.serviceFactory.oAuth2Service().isAuthorized()) {
        return GameChildishIconMode.UseLessNonChildishIcon;
    }

    return this.isVerifiedForRegulation()
         ? GameChildishIconMode.PreferLessNonChildishIcon
         : GameChildishIconMode.UseLessNonChildishIcon;
  }

  showTempAccountMessage() {
    TempAccountMessageRegulationHelper.create({
      serviceFactory: this.serviceFactory,
    }).showTempAccountMessage({
      messageKey: 'dk_temp_account_message'
    });
  }

  getTempAccountGnwpSource() {
    return GNWP_SOURCES.DOCUMENT_UPLOAD;
  }

  _handleRealityCheckMessage(sessionTimer) {
    const isGameRunning = this.serviceFactory.gameService().isGameRunning();
    if (isGameRunning) {
      if (!this._realityCheckShouldBeDisplayedInGame()) {
        return;
      }
    }

    this.serviceFactory.userService().getRealityCheckData().then(data => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
              playingTime: this.getCurrentSessionTime(),
              totalNetLoss: Check.isNullOrUndefined(data?.TotalNetLoss) ? 0 : data.TotalNetLoss,
              isInGame: isGameRunning,
              showPopupAboveSecondWebViewHybrid: true
      });

      this._structuredLogger.realityCheckMessageSuccess(data, this.getCurrentSessionTime());
    }).catch(err => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
              playingTime: this.getCurrentSessionTime(),
              totalNetLoss: 0,
              isInGame: isGameRunning
      });

      this._structuredLogger.realityCheckMessageError(err, this.getCurrentSessionTime().toString());
    });

  }

  _realityCheckShouldBeDisplayedInGame() {
    return this.serviceFactory
      .gameService()
      .shouldShowRealityCheckMessageWhileGameIsOpen();
  }
}
